module.exports = __webpack_public_path__ + "img/clothing207.e935f4bb.jpg";